import React from 'react';
import Proptypes from 'prop-types';

import { ctx } from './withTracking';
import { trackingURL } from './utils';

const TrackedLink = ({ children, href, conditions, trackingKey, ...props }) => {
  const getTrackingURL = trackingURL(href, trackingKey, conditions);
  return (
    <ctx.Consumer>
      {tracking => (
        <a href={getTrackingURL(tracking)} {...props}>
          {children}
        </a>
      )}
    </ctx.Consumer>
  );
};

TrackedLink.propTypes = {
  children: Proptypes.node,
  href: Proptypes.string.isRequired,
  trackingKey: Proptypes.string.isRequired,
  conditions: Proptypes.object,
};

export default TrackedLink;
